<template>
    <div class="legalContainer">
        <div class="legal-title">
            Legal & Compliance Settings
        </div>
        <div class="copyRightFrame">
            <div class="copyRightTitle">
                Copyright Disclaimer
            </div>
            <div class="copyRightText">
                This AI-powered doctor assistant provides general information based on the data provided. It is not intended to replace professional medical advice, diagnosis, or treatment. Always consult a qualified healthcare provider for medical concerns.
            </div>
        </div>
        <div class="copyRightFrame">
            <div class="copyRightTitle">
                Consultation Disclaimer
            </div>
            <div class="copyRightText">
                The prescriptions generated by {{store.MediAssistConfigManager.DomainName}} are automatically captured from the conversation and are based on the information provided during the consultation. 
            </div>
        </div>
        <div>
            <a :href="`${store.MediAssistConfigManager.MediAssistBaseUrl}/privacy-policy?p=${encodedValue}}`" class="privacy" target="_blank">Privacy Policy</a>
            , <a :href="`${store.MediAssistConfigManager.MediAssistBaseUrl}/wp-content/uploads/2025/10/MediNoteX-AI-MASTER-AGREEMENT-Subscription.pdf`" class="privacy" target="_blank">Governing Agreement</a>
            <span class="andText"> and </span>
            <a :href="`${store.MediAssistConfigManager.MediAssistBaseUrl}/terms-and-conditions?p=${encodedValue}`" class="terms" target="_blank">Terms and Conditions</a>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMyStore } from '@/store/store.ts';

const store = useMyStore()

const encodedValue = computed(() => encodeURIComponent(btoa('isloggedIn=true')));
</script>

<style>

.legalContainer{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    align-self: stretch;
    width: 100%;
    height: 540px;
}

.legal-title{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 29px;
    color: #1C1C1C;
    font-size: 22px;
    font-weight: 600;
}

.copyRightFrame{
    display: flex;
    padding: 10px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #E3E9F1;
}

.copyRightTitle{
    display: flex;
    align-items: center;
    gap: 7px;
    color: var(--Colors-Text-Colors-Text-Primary, #1C1C1C);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 24px */
}

.copyRightText{
    display: flex;
    align-items: center;
    gap: 7px;
    color: var(--Colors-Text-Colors-Text-Primary, #1C1C1C);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
}

.privacy, .terms{
    color: #0066D4;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    cursor: pointer;
    text-decoration: underline;
}

.privacy{
    padding-left: 5px;
}

.andText{
    color: #323233;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

</style>